// Module
var code = `<fragment-loader ng-if="\$ctrl.frameUrl && !\$ctrl.isCurrentPathAvailableInMFE" src="{{ \$ctrl.frameUrl }}" frame-name="blip-ai" class="h-100 w-100" on-load="\$ctrl.onFrontendLoad()" on-error="\$ctrl.onFrontendError()" error-message="{{ \$ctrl.errorMessage }}"></fragment-loader>`;
// Exports
module.exports = code;